import { theme as defaultTheme } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { Link } from "react-router-dom";
import { styled, css } from "styled-components";

export const StyledRow = styled.div`
  padding-top: 18px;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 24px;
`;

export const LinkWrapper = styled(Link)`
  border: 1px solid #c7c7c7;
  display: flex;
  flex: 0 1 270px;
  text-decoration: none;
  border-radius: 2px;
`;

export const Wrapper = styled.div`
  border: 1px solid #c7c7c7;
  display: flex;
  flex: 0 1 270px;
  text-decoration: none;
  border-radius: 2px;
  cursor: pointer;
`;

export const Inner = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ theme }) => {
    return `
      background-color: ${defaultTheme.COLORS.WHITE};

      &:hover {
        background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
    }
    `;
  }};
`;

export const Header = styled.div<{ hasImage?: boolean }>`
  display: flex;
  align-items: center;

  ${({ hasImage }) =>
    hasImage &&
    css`
      padding-top: 16px;
    `}

  & svg {
    margin-right: 12.5px;
  }
`;

export const Content = styled.div`
  padding-top: 10px;
  padding-bottom: 16px;
  margin-bottom: auto;
`;

export const StyledTypography = styled(Typography)`
  margin-bottom: 0;
`;

export const StyledLink = styled(Link)`
  type: button;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 24px;
  height: 40px;
  font-family: ${({ theme }) => defaultTheme.FONT.FAMILY.BODY};
  font-weight: ${({ theme }) => defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.STANDARD};
  border-radius: 70px;
  transition: 0.2s ease-in-out;

  ${({ theme }) => {
    return `
      color: ${defaultTheme.COLORS.BLACK_GREY};
      background-color: ${defaultTheme.COLORS.PRIMARY};
      border-width: 0px;

      &:not(.disable):hover {
        background-color: ${defaultTheme.COLORS.PRIMARY_DARK};
        transition: 0.2 ease-in-out;
      }

      &:disabled:hover {
        background-color: ${defaultTheme.COLORS.PRIMARY};
        border-width: 0px;
        opacity: 0.3;
      }

      &:disabled {
        background-color: ${defaultTheme.COLORS.PRIMARY};
        border-width: 0px;
        opacity: 0.3;
      }
    `;
  }};
`;

export const StyledImage = styled.img`
  max-width: 100%;
`;
